import { macroRegions, regions } from './autogen.partition';
var buildArrayMap = function (raw) {
    var res = {};
    raw.split('|').forEach(function (e) {
        var _a = e.split(':'), k = _a[0], vs = _a[1];
        res[k] = vs.split('');
    });
    return res;
};
var regionToPartition;
var macroRegionToPartitions;
var init = function () {
    regionToPartition = buildArrayMap(regions);
    macroRegionToPartitions = buildArrayMap(macroRegions);
};
export var getRegionPartition = function (region) {
    if (!regionToPartition) {
        init();
    }
    var result = regionToPartition[region] || macroRegionToPartitions[region];
    return result === undefined ? [] : result;
};
//# sourceMappingURL=partition.js.map